import { get } from 'lodash-es';

/**
 * Returns max cash value from terms range or direct rebateAmount fallback.
 * @param {object} incentive
 * @returns {number}
 */
export const getCashByTermsRange = incentive =>
  !incentive.cash && incentive?.incentiveTermRange?.length
    ? Math.max(...incentive.incentiveTermRange.map(term => get(term, 'customerCash', 0)))
    : (incentive.cash ?? incentive.rebateAmount ?? 0);
